const prefix = 'COMMON_ACTIONS::';

export const NEW_MESSAGE_IS_SENT = `${prefix}NEW_MESSAGE_IS_SENT`;

export const newMessageIsSent = () => ({type: NEW_MESSAGE_IS_SENT});